import { Component, ComponentInterface, h, Host, Prop } from '@stencil/core';

@Component({
    tag: 'rs-loader',
    styleUrl: 'rs-loader.css',
    shadow: true,
})
export class RsLoader implements ComponentInterface {
    @Prop() type: 'spinner' | 'indeterminate' = 'spinner';

    render() {
        return (
            <Host class={ this.type }>
                { this.type === 'spinner' ? this.spinner() : this.indeterminate() }
            </Host>
        );
    }

    private spinner() {
        return (
            <div class="loader rs-loader">Loading...</div>
        );
    }

    private indeterminate() {
        return (
            <div class="indeterminate-loader">
                <span><div class="indeterminate-loader__loading-bar"/></span>
            </div>
        );
    }
}